// ======================================================================
// File Name       : ServiceSearch
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col } from 'react-bootstrap';
import PaginationCustom from '../Pagination';
import CustomButton from '../button/CustomButton';
import * as ICON from '../../constants/IconConstants';
import CustomLink from '../button/CustomLink';
import * as Path from '../../constants/PathConstants';
import { WRITE } from '../../constants';

const ServiceSearch = ({
  serviceName,
  serviceCd,
  enterpriseName,
  dormantState,
  courseType,
  contentType,
  handleInputChange,
  serviceTypeHandleChange,
  handleChangeForDormantFlag,
  onSearchBtnClick,
  onExportBtnClick,
  isSuperUserL0,
  readOnlyFlag,
  canEditService
}) =>
  (<div>
    <Col sm={12} className="margin-top-10">
      <Form onSubmit={(e) => { e.preventDefault(); onSearchBtnClick(); }} className='form-horizontal'>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>サービスコード</Col>
          <Col sm={7}>
            <FormControl
              type="text"
              name="serviceCd"
              onChange={handleInputChange}
              value={serviceCd}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>サービス名</Col>
          <Col sm={7}>
            <FormControl
              type="text"
              name="serviceName"
              onChange={handleInputChange}
              value={serviceName}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>サービス種別</Col>
          <Col sm={3} className="padding-top-10">
            <Form.Check
              type='checkbox'
              checked={courseType}
              name="courseType"
              id="courseType"
              onChange={serviceTypeHandleChange}
              label='通常サービス'></Form.Check>
          </Col>
          <Col sm={5} className="padding-top-10">
            <Form.Check
              type='checkbox'
              checked={contentType}
              name="contentType"
              id="contentType"
              onChange={serviceTypeHandleChange}
              label='コンテンツ配信サービス'></Form.Check>
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col as={Form.Label} sm={3}>企業名</Col>
          <Col sm={7}>
            <FormControl
              type="text"
              name="enterpriseName"
              onChange={handleInputChange}
              value={enterpriseName}
            />
          </Col>
        </Form.Group>
        <Form.Group className="form-info">
          <Col sm={6} className="padding-top-3 padding-left-15">
            <Form.Check
              type='checkbox'
              checked={dormantState === 1}
              name="dormantState"
              id="dormantState"
              onChange={handleChangeForDormantFlag}
              label='休止したデータも表示する'></Form.Check>
          </Col>
        </Form.Group>
        <Form.Group className="form-info text-center">
          <Col sm={12}>
            <CustomButton
              btnStyle="btn btn-primary btn-96"
              text="検索"
              iconClass="bi bi-search"
              type="submit"
            />
          </Col>
        </Form.Group>
        <Form.Group>
          <Col sm={12} className="margin-bottom-15">
            <Col sm={9} className="inline-flex padding-clear">
              { isSuperUserL0 && !readOnlyFlag && canEditService && (
                <>
                  <CustomLink
                    className="btn-register margin-right-10"
                    to={Path.SERVICE_REGISTER}
                    text="サービス情報の新規登録"
                    icon={ICON.REGIST}
                  />
                  <CustomLink
                    className="margin-right-7 btn-csv-import"
                    to={Path.SERVICE_IMPORT}
                    text="CSV一括投入"
                    icon={ICON.IMPORT}
                  />
                </>
              )}
            </Col>
            <Col sm={3} className="display-flex justify-content-end float-end">
              <CustomButton
                btnStyle="btn btn-export-csv float-end"
                handleClick={onExportBtnClick}
                text="一括出力"
                iconClass="bi bi-download"
              />
            </Col>
          </Col>
        </Form.Group>
      </Form>
    </Col>
  </div>);

export default ServiceSearch;
